import type { ToastStyleConfig } from './types';

const DEFAULT_PROPS = {
  variant: 'subtle',
} as const;

export const TOAST_STYLE_CONFIG: ToastStyleConfig = {
  variants: {
    subtle: {},
    solid: {},
  },
  defaultProps: DEFAULT_PROPS,
};
